import { Col, Row } from "antd";
import { PageTitle } from "../../../../../styles/global/Pages.styled";
import { Text } from "../../../Atomics/Text";
import { useTranslation } from "react-i18next";
import useFetch from "../../../../../server/useFetch";
import { Widget } from "../../../Atomics/Widget";
import { NoData } from "../../../Atomics/NoData";
import { IconWrapper } from "@synergy/icons";

export const HomepageWaterCharts = () => {
    const { t } = useTranslation();
    const { data: waterData, refetch: refetchWaterData, isFetching: waterDataIsFetching, remove: removeWaterData } = useFetch(
        `/nova_wallboards/getwaterdata`, "waterData",
        null, null, null, 'https://36lsp94v05.execute-api.eu-west-1.amazonaws.com/v3_0_01', 300000);

    return (
        <Row gutter={[16, 16]}>
            <Col span={24} id="water">
                <PageTitle>
                    <Text $fontColor="coolgray-12" $fontSize="text_md" $weight="medium" $marginRight="s03">{t("Water")}</Text>
                </PageTitle>
            </Col>
            <Col span={6}>
                <Widget
                    data={{
                        background: "transparent",
                        title: t("title.Incidents by priority"),
                        icon: 'Clipboard',
                        border: null,
                        background: 'white',
                        height: '100%',
                        activeShadow: true,
                        margin: "0 0 10px 0",
                    }}
                >
                    {waterData?.incidents ?
                        getByPriorityWidget(waterData?.incidents, t)
                        : <NoData />}
                </Widget>
            </Col>
            <Col span={9}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.General Consume"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "bigNumberChart",
                                chartId: "bigNumberChartOne",
                                height: "111px",
                                isFetching: waterDataIsFetching,
                                data: waterData?.waterGeneralConsume
                                    ? {
                                        number: waterData.waterGeneralConsume,
                                        unit: "m³/semana",
                                    language: 'de-DE'
                                    }
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={9}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Buildings Consumption"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "bigNumberChart",
                                chartId: "bigNumberChartOne",
                                height: "111px",
                                isFetching: waterDataIsFetching,
                                data: waterData?.totalWaterConsumeInWeek
                                    ? {
                                        number: waterData.totalWaterConsumeInWeek,
                                        unit: "m³/semana",
                                    language: 'de-DE'
                                    }
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={24}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Weekly Consumption By Building"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "columnsChartApex",
                                height: "200px",
                                isFetching: waterDataIsFetching,
                                data: waterData?.consumeByBuildings
                                    ? getColumnChartData(waterData?.consumeByBuildings)
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={12}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Consumption on the Previous Day"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "areaChartApex",
                                height: "200px",
                                isFetching: waterDataIsFetching,
                                data: waterData?.waterConsumePreviousDayChart
                                    ? getAreaChartData(waterData?.waterConsumePreviousDayChart)
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
            <Col span={12}>
                <Widget
                    data={{
                        tooltip: t("title.Data from Sunday to Saturday"),
                        background: "white",
                        title: t("title.Water Consumption"),
                        icon: null,
                        activeShadow: true,
                        charts: [
                            {
                                chartType: "areaChartApex",
                                height: "200px",
                                isFetching: waterDataIsFetching,
                                data: waterData?.waterConsumeWeekChart
                                    ? getAreaChartData(waterData?.waterConsumeWeekChart)
                                    : null,
                            },
                        ],
                    }}
                />
            </Col>
        </Row>
    );
};

const getByPriorityWidget = (data, t) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly' }}>


                {[{ label: 'Red', count: data["red"] ?? 0 },
                { label: 'Orange', count: data["orange"] ?? 0 },
                { label: 'Yellow', count: data["yellow"] ?? 0 }].map((status, index) => (
                    <div key={index} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '30%', marginBottom: '20px' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <IconWrapper $bgColor={status.label} $bgsize="5px" />
                            <h1 style={{ margin: '0', marginLeft: '5px' }}>{status.count}</h1>
                        </div>
                        {/* <span>{t(status.label)}</span> */}
                    </div>
                ))}
            </div>
        </div>
    );
};

const getColumnChartData = (data, t) => {
    const series = data.map((item) => {
        return {
            x: item.name,
            y: item.uv,
        }
    });

    return {
        series: [
            {
                name: '',
                data: series,
            }
        ],
        categories: [],
        tooltip: null,
        unit: "m³",
        columnWidth: 20,
        xAxisLabel: null,
        yAxisLabel: "m³",
        color: ['yellow'],
        tickAmount: 12,
        showTooltipTitle: true,
        showLegend: false,
        hideToolbar: true,
    };
};

const getAreaChartData = (data) => {
    const series = data.map((item) => {
        return {
            x: item.name,
            y: item.uv,
        }
    });

    return {
        series: [
            {
                name: "",
                data: series,
            }
        ],
        categories: null,
        markerSize: 3,
        unit: "m³",
        yAxisLabel: "m³",
        columnWidth: 20,
        colors: ["#66cbc8"],
        hideToolbar: true,
        hideLegend: true,
    }
};